import { takeLatest, put, all, call } from 'redux-saga/effects'

import api from '~/services/api'

import {
  Types,
  updateCampaigns,
  updateCampaignStoreRules,
  updateCampaignFields
} from './actions'

export function * getCampaigns ({ payload }) {
  const { storeId } = payload

  if (!storeId) yield put(updateCampaigns({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = `/stores/${storeId}/campaigns`

  try {
    const response = yield call(
      api.get,
      url
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data) {
        yield put(updateCampaigns({ campaigns: response.data.data }))
      } else {
        yield put(updateCampaigns({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateCampaigns({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateCampaigns({ error: error.message }))
  }
}

export function * getCampaignStoreRules ({ payload }) {
  const { campaignId } = payload

  if (!campaignId) yield put(updateCampaignStoreRules({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = `/campaign/${campaignId}/rules/store`

  try {
    const response = yield call(
      api.get,
      url
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        yield put(updateCampaignStoreRules({ storeRules: response.data.data }))
      } else {
        yield put(updateCampaignStoreRules({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateCampaignStoreRules({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateCampaignStoreRules({ error: error.message }))
  }
}

export function * getCampaignFields ({ payload }) {
  const { campaignId } = payload

  if (!campaignId) yield put(updateCampaignFields({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = `/campaign/${campaignId}/fields`

  try {
    const response = yield call(
      api.get,
      url
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        yield put(updateCampaignFields({ fields: response.data.data }))
      } else {
        yield put(updateCampaignFields({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateCampaignFields({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateCampaignFields({ error: error.message }))
  }
}

export default all([
  takeLatest(Types.getCampaigns, getCampaigns),
  takeLatest(Types.getCampaignStoreRules, getCampaignStoreRules),
  takeLatest(Types.getCampaignFields, getCampaignFields)
])
